import Vue from 'vue';
// tslint:disable-next-line:no-import-side-effect
import 'vuetify/src/stylus/app.styl';
import Vuetify, {VApp} from 'vuetify/lib';

// import fr from 'vuetify/src/locale/fr'
Vue.use(Vuetify, {
	components: {
		VApp,
	},
	iconfont: 'fa',
	/* lang: {
		locales: {
			fr
		},
		current: 'fr',
	}, */
	theme: {
		accent: '#82B1FF',
		error: '#FF5252',
		info: '#2196F3',
		primary: '#31313B',
		secondary: '#424242',
		success: '#4CAF50',
		warning: '#FFC107',
	},
});
